/** Capture beforeinstallprompt as early as possible (module singleton). */

let deferredPrompt = null;
const promptListeners = new Set();

export function initPwaInstallCapture() {
  if (typeof window === 'undefined') return;
  if (window.__maveshiPwaCaptureInit) return;
  window.__maveshiPwaCaptureInit = true;

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    promptListeners.forEach((listener) => listener(event));
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    promptListeners.forEach((listener) => listener(null));
  });
}

export function getDeferredInstallPrompt() {
  return deferredPrompt;
}

export function subscribeDeferredInstallPrompt(listener) {
  promptListeners.add(listener);
  if (deferredPrompt) listener(deferredPrompt);
  return () => promptListeners.delete(listener);
}

export function clearDeferredInstallPrompt() {
  deferredPrompt = null;
}

export function isPwaStandaloneMode() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches
    || window.navigator.standalone === true
  );
}

/** Phone / tablet — not desktop Chrome on a laptop. */
export function isMobileLikeDevice() {
  if (typeof window === 'undefined') return false;

  if (navigator.userAgentData?.mobile === true) return true;

  const ua = navigator.userAgent || '';
  if (/android|iphone|ipad|ipod|mobile|webos|blackberry|iemobile|opera mini/i.test(ua)) {
    return true;
  }
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }
  if (window.matchMedia('(pointer: coarse)').matches && window.innerWidth < 1280) {
    return true;
  }
  return false;
}

export function isIosLikeDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return (
    /iphone|ipad|ipod/i.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

export function isAndroidLikeDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return true;
  if (isMobileLikeDevice() && !isIosLikeDevice() && /chrome|edg|samsung|firefox/i.test(ua)) {
    return true;
  }
  return false;
}

export function getInstallPlatform() {
  if (isIosLikeDevice()) return 'ios';
  if (isAndroidLikeDevice()) return 'android';
  if (isMobileLikeDevice()) return 'mobile';
  return 'desktop';
}
